import React , { useState } from 'react';
import { Link } from 'react-router-dom'

const Action2 = () => {

    const [data] = useState(
        {
            title: 'Join us Fren!',
            desc: 'Fill out the listing form to get your project trading on PepeX Today!',
        }
    )

    return (
        <section className="tf-section action">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="action__body" data-aos="fade-up">
                            <div className="block-text">
                                <h3 className="mb-13">{data.title}</h3>
                                <p className="fs-21 mb-7">{data.desc}</p>
                            </div>
                            <a href='https://docs.google.com/forms/d/1rcT6MSJegsoMhZ24FT8R6li7KrC_DU1AP8yfXUdor8E/viewform?edit_requested=true' className="btn-action" target="_blank" rel="noopener noreferrer">
            Listing Form
        </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Action2;